import { sb } from '../supabase';

// Growth OS «المنتجات» — the five product-health lists (report section C).
// The server builds them (growth_product_lists, owner only) from
// growth_product_daily, which a nightly job fills from clean events and paid
// orders. This file only fetches and words the reasons.

export async function fetchProductLists(range) {
  const { data, error } = await sb.rpc('growth_product_lists', { p_from: range.from, p_to: range.to, p_limit: 25 });
  if (error) throw error;
  return data;
}

export const BLOCK_AR = {
  price: 'السعر', moq: 'الحد الأدنى للطلب', shipping: 'خيارات الشحن والتوصيل', qty_table: 'جدول الكميات',
  save_upsell: '«اطلب N قطعة ووفّر»', none: 'لم يصل لأي جزء من الصفحة',
};
const SEA_WHY_AR = { not_measured: 'غير مقاس', type_unknown: 'نوع غير معروف', volume_outlier: 'حجم غير معقول', sea_dearer: 'البحري أغلى' };
const HOLD_AR = {
  no_weight_large: 'كبير بلا وزن', no_weight_no_estimate: 'بلا وزن ولا تقدير', tiny_weight_listing: 'وزن صغير جداً',
  tiny_weight_variant: 'وزن صغير جداً', liquid_bulk_unit: 'سائل بكميات', implausible_large_item: 'حجم غير معقول',
  non_product_listing: 'ليس منتجاً', import_checking: 'قيد فحص الاستيراد', manual: 'يدوي',
};

// «N يوماً» with Arabic counting: 1 يوماً واحداً · 2 يومين · 3–10 أيام · else يوماً.
export function daysAr(n) {
  if (n === 1) return 'يوماً واحداً';
  if (n === 2) return 'يومين';
  if (n >= 3 && n <= 10) return `${n} أيام`;
  return `${Number(n).toLocaleString('en-US')} يوماً`;
}

export const pct = (a, b) => (b > 0 ? Math.round((a / b) * 1000) / 10 : null);

// Why a product is on «ناقصة البيانات وتنفتح» — every reason it has, in words.
export function gapReasons(r) {
  const out = [];
  if (r.level === 'none') out.push('لا يوجد وزن صالح لحساب الشحن');
  if (r.level === 'weight') out.push('الوزن موجود والحجم مشكوك فيه');
  if (r.sea_ok === false) out.push(`الشحن البحري غير متاح${r.sea_why ? ` (${SEA_WHY_AR[r.sea_why] || r.sea_why})` : ''}`);
  (r.holds || []).forEach((h) => out.push(`محجوب: ${HOLD_AR[h] || h}`));
  return out;
}

// Admin: the missing-weights page can show a product whose measures are not
// sound, found by its 1688 id. There is no single-product admin page yet, so
// other rows link to the product's source instead.
export function adminLink(r) {
  if (r.source_product_id && r.level && r.level !== 'measured') {
    return { href: `/admin2/market-weights?q=${encodeURIComponent(r.source_product_id)}&status=all&level=${r.level}`, label: 'في الإدارة', internal: true };
  }
  if (r.source_url) return { href: r.source_url, label: 'المصدر (1688)', internal: false };
  return null;
}
